module.exports = __webpack_public_path__ + "img/logo.bf2c8565.png";